export enum LanguageCode {
  EN = 'EN',
  RO = 'RO',
  FR = 'FR',
}

export const SUPPORTED_LANGUAGES_CONSTANTS = [
  { code: LanguageCode.EN, label: 'English', flag: 'assets/flags/en.svg' },
  // { code: LanguageCode.FR, label: 'Français', flag: 'assets/flags/fr.svg' },
  // { code: LanguageCode.RO, label: 'Română', flag: 'assets/flags/ro.svg' },
];

export const LANGUAGES_CONSTANTS = {
  LANGUAGEKEY: 'LANGUAGEKEY',
} as const;
